import { microCopy } from "@bmi-digital/dxb-microcopies";
import { CalculatorSteps, type Data } from "../types";
import { useAnalyticsContext } from "../helpers/analytics";
import { useSiteContext } from "../../Site";
import type { Tile, TileOptionSelections, Underlay } from "../types";
import type { DimensionsValues, RoofV2 as Roof } from "../types/roof";
import type { GutteringSelections } from "../_Guttering";

const useResultsStep = ({
  setSelectedStep,
  data,
  setRoof,
  setDimensions,
  setSelectedMaterial,
  setMainTileCode,
  setVariant,
  setTileOptions,
  setUnderlay,
  setGuttering
}: {
  setSelectedStep: (step: CalculatorSteps) => void;
  data: Data;
  setRoof: (roof?: Roof) => void;
  setDimensions: (dimensions: DimensionsValues) => void;
  setSelectedMaterial: (material?: string) => void;
  setMainTileCode: (code?: string) => void;
  setVariant: (tile?: Tile) => void;
  setTileOptions: (tileOptions?: TileOptionSelections) => void;
  setUnderlay: (underlay?: Underlay) => void;
  setGuttering: (guttering?: GutteringSelections) => void;
}) => {
  const pushEvent = useAnalyticsContext();
  const { getMicroCopy } = useSiteContext();

  const resetSelectedData = () => {
    setRoof(undefined);
    setDimensions({});
    setSelectedMaterial(undefined);
    setMainTileCode(undefined);
    setVariant(undefined);
    setTileOptions(undefined);
    setUnderlay(undefined);
    setGuttering(undefined);
  };

  const resultsGoBackHandler = () => {
    pushEvent({
      event: "dxb.button_click",
      id: "rc-solution",
      label: getMicroCopy(microCopy.RESULTS_BACK_LABEL),
      action: "selected"
    });

    if (Object.keys(data.gutters).length) {
      setSelectedStep(CalculatorSteps.Guttering);
      return;
    }

    setSelectedStep(CalculatorSteps.SelectUnderlay);
  };

  const resultsResetSelectionHandler = () => {
    pushEvent({
      event: "dxb.button_click",
      id: "rc-solution",
      label: getMicroCopy(microCopy.RESULTS_START_OVER_LABEL),
      action: "selected"
    });

    setSelectedStep(CalculatorSteps.SelectRoof);
    resetSelectedData();
  };

  return { resultsGoBackHandler, resultsResetSelectionHandler };
};

export default useResultsStep;
